import {LoadAsset} from './LoadAsset.class';
import {LoadAssetGroup} from './LoadAssetGroup.class';

export class RestChunkAssetGroup extends LoadAssetGroup {
  constructor(loadAssetList: LoadAsset[]) {
    super({type: 'RestChunk', loadAssetList});
  }
}
